const $ = window.jQuery;
import Splide from "@splidejs/splide";
$(function () {
	// let videoTab = $(".videos_tab");
	// let photoTab = $(".photos_tab");
	let photo_tab_content_horizontal = document.querySelectorAll(".photo-tab-content-horizontal");
	if (photo_tab_content_horizontal.length > 0) {
		for (let i = 0; i < photo_tab_content_horizontal.length; i++) {
			let photo_tab_content_horizontalElement = photo_tab_content_horizontal[i];
			let photo_tab_content_horizontalDefaultOptions = {
				type: "slide",
				arrows: false,
				pagination: false,
				autoWidth: true,
				trimSpace: "move",
				focus: "center",
				gap: "1rem",
			};
			let carousel = new Splide(photo_tab_content_horizontalElement, photo_tab_content_horizontalDefaultOptions);
			carousel.mount();
		}
	}

	let video_tab_content_horizontal = document.querySelectorAll(".video-tab-content-horizontal");

	if (video_tab_content_horizontal.length > 0) {
		for (let i = 0; i < video_tab_content_horizontal.length; i++) {
			let video_tab_content_horizontalElement = video_tab_content_horizontal[i];
			let video_tab_content_horizontalDefaultOptions = {
				type: "slide",
				arrows: false,
				pagination: false,
				autoWidth: true,
				trimSpace: "move",
				focus: "center",
				gap: "1rem",
			};

			let videoCarousel = new Splide(video_tab_content_horizontalElement, video_tab_content_horizontalDefaultOptions);
			videoCarousel.mount();
		}
	}
});
